import { CurrencyPipe } from '@angular/common'
import { inject, Pipe, PipeTransform } from '@angular/core'
import { ExchangeRateService } from '@shared/services/exchange-rate.service'
import { getCurrencyDisplayFormat } from '@shared/constants/currency-display.const'
import { isNil } from 'lodash'

@Pipe({ name: 'convertCurrency', pure: true })
export class ConvertCurrencyPipe extends CurrencyPipe implements PipeTransform {
  private exchangeRateService = inject(ExchangeRateService)

  override transform(value, currencyCode?, display?, digitsInfo?, locale?): null
  override transform(value, currencyCode?): string | null {
    if (
      !isNil(value) &&
      value != '' &&
      this.exchangeRateService.exchangeRate?.exchangeRate &&
      this.exchangeRateService.exchangeRate.exchangeRate != 1
    ) {
      value = typeof value === 'string' ? Number(value) : value
      value = value * this.exchangeRateService.exchangeRate.exchangeRate
    }
    const displayFormat = getCurrencyDisplayFormat(currencyCode)

    return !isNil(value) ? super.transform(value, currencyCode, displayFormat)?.replace(/-/g, '‑') : '--'
  }
}
